import { reactive, getCurrentInstance } from "vue";
import { useFilters } from "@/composables/filters/useFilters";
import { getProficiencyBadgeProps } from "@components/utils/proficiencyBadgeView";
import { deleteResponsibilityBadge } from "@/api";
let instance = null;

export function useViewState() {
  if (instance) return instance;
  const filter = useFilters();
  const app = getCurrentInstance();
  const { proxy } = app || {};
  const state = reactive({
    filters: {
      values: [],
      searchText: "",
      showFilterDialog: false,
      key: "readinessEmployees",
      clearSelection: "",
      needsRecalculation: false,
    },
    loading: {
      table: false,
    },
    table: {
      currentPage: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
      search: "",
    },
    showRemoveBadgeDialog: false,
    selectedBadge: null,
    getCoachResponsibilties: false,
    isForceBadge: false,
    currentResponsibilityName: "",
  });

  const applyFilters = (filters) => {
    const newArray = filters
      .map((item) => {
        if (item.value !== null) {
          if (typeof item === "string") {
            return item;
          } else if (
            typeof item === "object" &&
            // eslint-disable-next-line no-prototype-builtins
            item.hasOwnProperty("value")
          ) {
            return item.value;
          }
        }
      })
      .filter(Boolean);
    filter.setFilters({ key: state.filters.key, filters: newArray });
    state.filters.values = newArray;
    state.filters.showFilterDialog = false;
  };

  const removeFilters = (removedFilters) => {
    filter.setFilters({
      key: state.filters.key,
      filters: state.filters.values,
    });
    state.filters.clearSelection = removedFilters;
  };
  const getEmployeeCardProps = (data) => {
    return {
      firstName: data?.employee?.first_name,
      lastName: data?.employee?.last_name,
      position: data?.employee?.title,
      photoUrl: data?.employee?.avatar,
      availability: data?.employee?.availability,
      showAvailability: true,
      showLinkUnderline: false,
      hideAvailabilitySelector: data?.employee?.primary_positions?.length > 0 || false,
      isAllocated: data?.employee?.primary_positions?.length > 0 || false,
      isHoverEnabled: false,
    };
  };
  const getInspectionIssueBadgeProps = (obj) => {
    return {
      currentBadgeLevel: obj.currentBadgeLevel,
      currentBadgeStatus: obj.currentBadgeStatus,
      checkpoints: obj.checkpoints,
      useCountsVariant: true,
      checkpointCounts: obj.checkpointCounts || {},
      // showInspectionButtons: true,
    };
  };
  const getOrgObjectCardProps = (obj) => {
    return {
      code: obj.code,
      name: obj.name,
      showIcon: false,
      removeUnderlineToName: true,
      dynamicWidth: true,
      maxWidth: "450px",
    };
  };
  const getSwitcherProps = (obj) => {
    return {
      label: "",
      value: obj.isCoach,
    };
  };
  const handleOptionClick = (item) => {
    state.currentResponsibilityName = item.name;
    const hasActiveStatus = item.checkpoints.some((item) => item.status == "active");
    // viewState.state.isForceBadge = true;
    if (hasActiveStatus) {
      state.isForceBadge = false;
    } else {
      state.isForceBadge = true;
    }
  };

  const updateFilter = (filterName, value) => {
    if (filterName in state.filters) {
      state.filters[filterName] = value;
    }
  };

  const clearFilters = () => {
    // ER-11195: "Clear all" restores the documented defaults from the central
    // registry instead of resetting the whole filters object to a legacy shape.
    state.filters.values = filter.resetToDefaults(state.filters.key);
    state.filters.showFilterDialog = false;
  };

  const setLoading = (key, value) => {
    if (key in state.loading) {
      state.loading[key] = value;
    }
  };
  const removeProficiencyBadge = (item) => {
    state.showRemoveBadgeDialog = true;
    state.selectedBadge = item;
  };
  const handleRemoveBadge = async ({ reason: removeReason } = {}) => {
    proxy.$loader.setAppLoading(true);
    try {
      const payload = {
        badge: state.selectedBadge?.badge?.id,
        method: "removed",
        reason: removeReason ? removeReason.trim() : "removed",
      };
      const accountID = localStorage.getItem("currentAccountID");
      await deleteResponsibilityBadge(accountID, state.selectedBadge?.badge?.id, payload);
      state.getCoachResponsibilties = true;
      state.showRemoveBadgeDialog = false;
    } catch (e) {
      console.error("Error removing badge: ", e);
    } finally {
      proxy.$loader.setAppLoading(false);
    }
  };

  instance = {
    state,
    updateFilter,
    clearFilters,
    setLoading,
    getOrgObjectCardProps,
    getSwitcherProps,
    applyFilters,
    removeFilters,
    getEmployeeCardProps,
    getProficiencyBadgeProps,
    getInspectionIssueBadgeProps,
    removeProficiencyBadge,
    handleRemoveBadge,
    handleOptionClick,
  };
  return instance;
}
